import { render, staticRenderFns } from "./imgLoadCollection.vue?vue&type=template&id=67d61aaa"
import script from "./imgLoadCollection.vue?vue&type=script&lang=js"
export * from "./imgLoadCollection.vue?vue&type=script&lang=js"
import style0 from "./imgLoadCollection.vue?vue&type=style&index=0&id=67d61aaa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports